import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { ResponsePlaceDto, PlaceDto } from '../types/dtos';
import { APP_ENDPOINTS } from 'app/endpoints';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.mutation<ResponsePlaceDto, PlaceDto>({
        query: (payload) => ({
            url: APP_ENDPOINTS.PLACES,
            method: 'POST',
            body: payload,
        }),
        invalidatesTags: [
            { type: 'places-with-join', id: 'GET-JOIN' },
            { type: 'places', id: 'GET' },
        ],
    });
